import { MergeMaps } from '../../../misc/helpers/map/merge';
export function GetRoutesPathParams(routesPath, path) {
    var params = new Map();
    for (var i = 0, l = routesPath.length; i < l; i++) {
        var route = routesPath[i];
        var result = route.pathMatcher.exec(path);
        if (result === null) {
            throw new Error("The routePath doesn't match the path");
        }
        else {
            MergeMaps(params, result.params);
            path = result.remaining;
        }
    }
    return params;
}
//# sourceMappingURL=get-routes-path-params.js.map